import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { scrollTo } from "core-web/utils/scrollFunctions";
import styled from "theme/libs/styled";
import Pagination from "theme/components/ListProducts/Pagination";
import ArticleCard from "theme/components/articles/ArticleCard";
import ScalingGridWrapper from "theme/components/wrappers/ScalingGridWrapper";

const Wrapper = styled("div")``;

const Grid = styled(ScalingGridWrapper)`
    row-gap: 8px;

    & > * {
        grid-column: span 12;
        ${({ theme }) => theme.above.tabletSm} {
            grid-column: span 4;
            row-gap: 16px;
        }
    }

    ${({ theme }) => theme.above.mobileLg} {
        row-gap: 12px;
    }

    ${({ theme }) => theme.above.tabletLg} {
        row-gap: 16px;
    }
`;

const ArticleGrid = ({ response, isSearchPage }) => {
    const { t } = useTranslation();
    const wrapperRef = useRef();
    const { hits: articles = [], pagination = {} } = response || {};
    const { hits = 0, pageSize = 12, hitsCount = 0, page = 0, pageCount = 1, offset = 0 } = pagination;
    const hasArticles = Array.isArray(articles) && articles.length;
    const clonedArticles = JSON.parse(JSON.stringify(articles || []));
    const slicedArticles = page === 0 && !isSearchPage ? clonedArticles.slice(1) : clonedArticles;

    const clickPagination = () => {
        // Scroll back to top of wrapper on pagination
        if (wrapperRef.current) {
            scrollTo({
                smooth: false,
                top: wrapperRef.current.offsetTop - 100,
            });
        }
    };

    if (!hasArticles) {
        return null;
    }

    return (
        <Wrapper ref={wrapperRef}>
            <Grid>
                {slicedArticles.map((article, index) => {
                    return <ArticleCard key={`${article.heading}_${index}`} {...article} />;
                })}
            </Grid>
            {pageCount > 1 && (
                <Pagination
                    hitsCount={hitsCount}
                    offset={offset}
                    page={page}
                    pageCount={pageCount}
                    pageSize={pageSize}
                    hits={hits}
                    suffix={t("articles.articles")}
                    handleClick={clickPagination}
                />
            )}
        </Wrapper>
    );
};

ArticleGrid.propTypes = {
    isLazyLoading: PropTypes.bool,
    response: PropTypes.shape({
        articles: PropTypes.array,
        handleChange: PropTypes.func,
        isSearchPage: PropTypes.bool,
        pagination: PropTypes.shape({
            hits: PropTypes.number,
            hitsCount: PropTypes.number,
            offset: PropTypes.number,
            page: PropTypes.number,
            pageCount: PropTypes.number,
            pageSize: PropTypes.number,
        }),
        tags: PropTypes.arrayOf(PropTypes.string),
        totalHits: PropTypes.number,
    }).isRequired,
    isSearchPage: PropTypes.bool,
};

ArticleGrid.defaultProps = {
    isLazyLoading: true,
    isSearchPage: false,
};

export default ArticleGrid;
